export const trackPageView = () => {
  if (typeof window.gtag !== "function") return;

  window.gtag("config", "G-QVSCJ8PGNK", {
    page_path: window.location.pathname,
  });
};